import { createIconComponent } from '../../factory/create-icon-component';
export const UserCircleIcon = createIconComponent(
  'UserCircleIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 13H10.6667C9.19391 13 8 14.1939 8 15.6667C8 16.403 8.59695 17 9.33333 17H14.6667C15.403 17 16 16.403 16 15.6667C16 14.1939 14.8061 13 13.3333 13Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="8"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
